module.exports = __webpack_public_path__ + "img/home-3-hero-cloud.ce58614e.svg";